module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-c78ebc5c671e73e20b67d1d91fd71c18.png";